import {
	stateOrgControlConstants
}from "./constants"
import actions from '../../actions'
const initialState = {
	isSending : false,
	paged     : null,
	changed   : null,
	error     : null,
	count     : null
}

export default function (state = initialState, action){
	switch (action.type){
		case stateOrgControlConstants.Create.REQUEST:
		case stateOrgControlConstants.Update.REQUEST:
		case stateOrgControlConstants.Delete.REQUEST:
		case stateOrgControlConstants.GetPaged.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case stateOrgControlConstants.Update.FAILURE:
		case stateOrgControlConstants.Create.FAILURE:
		case stateOrgControlConstants.Delete.FAILURE:
		case stateOrgControlConstants.GetPaged.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}

		case stateOrgControlConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}

		case stateOrgControlConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}

		case stateOrgControlConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}

		case stateOrgControlConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result.items,
				count     : action.payload.result.count
			}

		case stateOrgControlConstants.CLEAR:
			return {
				...state,
				isSending : false,
				paged     : null,
				changed   : null,
				error     : null,
				count     : null
			}
		default:
			return state
	}
}
